@if (activiteitenPage$ | async; as activiteitenPage) {
  @if (zones$ | async; as zones) {
    @if (diensten$ | async; as diensten) {
      <zah-activiteit-header>
      </zah-activiteit-header>
      <zah-activiteiten [initialPageRequest]="initialPageRequest"
        [activiteitenPage]="activiteitenPage"
        [zones]="zones"
        [diensten]="diensten"
        (verwerkClicked)="onVerwerkClicked($event)"
        (activiteitClicked)="onActiviteitClicked($event)"
        (pageChange)="onPageChange($event)">
      </zah-activiteiten>
    }
  }
}
